import React, { useState } from 'react';
import { Card, Tabs } from 'antd';
import { FileTextOutlined, GlobalOutlined, NotificationOutlined, PhoneOutlined, StarOutlined } from '@ant-design/icons';
import BlogScreen from '../BlogsScreen/BlogsScreen';
import NewsScreen from '../News/News';
import AdsScreen from '../AdsScreen/AdsScreen';
import ContactScreen from '../Contact/Contact';
import ReviewQrGeneration from '../ReviewQrGeneration/ReviewQrGeneration';
  const role=localStorage.getItem("role");

const MarketingAndContent = () => {
    const [activeTab, setActiveTab] = useState('blogs');

    const tabItems = [
        {
            key: 'blogs',
            label: (
                <span className="flex items-center gap-2">
                    <FileTextOutlined />
                    Blogs
                </span>
            ),
            children: <BlogScreen />,
        },
        {
            key: 'news',
            label: (
                <span className="flex items-center gap-2">
                    <GlobalOutlined />
                    Center News
                </span>
            ),
            children: <NewsScreen />,
        },
        {
            key: 'ads',
            label: (
                <span className="flex items-center gap-2">
                    <NotificationOutlined />
                    Campaign Ads
                </span>
            ),
            children: <AdsScreen />,
        },
    role!=7&&    {
            key: 'review',
            label: (
                <span className="flex items-center gap-2">
                    <StarOutlined />
                    Review By Qr 
                </span>
            ),
            children: <ReviewQrGeneration />,
        },
        {
            key: 'contact',
            label: (
                <span className="flex items-center gap-2">
                    <PhoneOutlined />
                    Contacts 
                </span>
            ),
            children: <ContactScreen />,
        },

    ];

    return (
        <div className="min-h-screen bg-[#F7FCFD]">
            <div className="">
                <Card className="shadow-lg border-0 bg-white/90 backdrop-blur-sm mt-6">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                    />
                </Card>
            </div>
        </div>
    );
};

export default MarketingAndContent;